import React, { Component } from "react";
import JobTrackIframeEmbed from "components/common/JobTrackIframeEmbed";
import TwoColumnLayout from "layouts/TwoColumn";
import StorageGateway from "lib/storage-gateway";

class IframeBudgetList extends Component {
  render() {
    const { empId } = this.props;
    const JobTrackAuthToken = StorageGateway.get("JobTrackBearerToken");
    const JobTrackRefreshToken = StorageGateway.get("jobTrackRefreshToken");

    const orgId = StorageGateway.get("jobTrackOrgId");
    const jwtToken = StorageGateway.get("iframe_jwt_token");
    const iframeSrc1 = `${
      process.env.REACT_APP_JOBTRAKS_BASE_URL
    }screen/89/budgetmapper?access_token=${JobTrackAuthToken}&refresh_token=${JobTrackRefreshToken}&orgId=${orgId}&Employee%20Budget=${encodeURIComponent(
      `{"employee_id":"${empId}"}`
    )}&Create%20Budget=${encodeURIComponent(
      `{"employee_id":"${empId}"}`
    )}&embed=true`;

    return (
      <div
        style={{
          height: "calc(90vh - 102px - 80px)",
          marginRight: "-15px",
        }}
      >
        {" "}
        <JobTrackIframeEmbed src={iframeSrc1} type="tab" />
      </div>
    );
  }
}

export default IframeBudgetList;
